import { action } from 'satcheljs';
import type { ClientAttachmentId } from 'owa-client-ids';

export interface REFRESH_SHARING_TIPS_FOR_ATTACHMENTActionMessage {
    attachmentId: ClientAttachmentId;
}

export interface SET_ATTACHMENT_CONTENTIDActionMessage {
    attachmentId: ClientAttachmentId;
    attachmentContentId: string;
}
export const setAttachmentContentId: (
    attachmentId: ClientAttachmentId,
    attachmentContentId: string
) => SET_ATTACHMENT_CONTENTIDActionMessage = action(
    'SET_ATTACHMENT_CONTENTID',
    (
        attachmentId: ClientAttachmentId,
        attachmentContentId: string
    ): SET_ATTACHMENT_CONTENTIDActionMessage => ({
        attachmentId,
        attachmentContentId,
    })
);

export interface SET_ATTACHMENT_ISINLINEActionMessage {
    attachmentId: ClientAttachmentId;
    isInline: boolean;
}
export const setAttachmentIsInline: (
    attachmentId: ClientAttachmentId,
    isInline: boolean
) => SET_ATTACHMENT_ISINLINEActionMessage = action(
    'SET_ATTACHMENT_ISINLINE',
    (
        attachmentId: ClientAttachmentId,
        isInline: boolean
    ): SET_ATTACHMENT_ISINLINEActionMessage => ({
        attachmentId,
        isInline,
    })
);
